import React from "react";
import { useLocation } from "react-router-dom";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const ShareReportPage = () => {
  const location = useLocation();

  const fileName = location.pathname.split("/")[2];

  const fileUrl = `${process.env.REACT_APP_API_URL}/shared-report/${fileName}.pdf`;

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      <Viewer
        fileUrl={fileUrl}
        defaultScale={SpecialZoomLevel.PageWidth}
        plugins={[defaultLayoutPluginInstance]}
      />
    </Worker>
  );
};

export default ShareReportPage;
